module.exports = __webpack_public_path__ + "img/2_1-residenziale-edicola-2.3f6b673f.png";